<template>
    <section class="section-padding" id="review">
      <div class="container-fluid container-lg">
        <div class="row justify-content-center align-items-center">
            <div class="col-12 text-center section-header">
                <h2 class="mb-2">Our Reviews</h2>
                <p>Read what our customers are saying about us</p>
            </div>
        </div>

        <div class="row justify-content-center align-items-center mt-3 px-4 px-md-5">
            <carousel :per-page="1" :mouse-drag="true" :autoplay="true" :autoplayHoverPause="false" :navigationEnabled="false" :paginationEnabled="false" :autoplayTimeout="8000" :speed="600" paginationColor=#000000 paginationActiveColor="#ff9900" :loop="true">
            <slide>
                <div class="review-box p-4">
                    <h3 class="mb-3">James Marketer</h3>
                    <p>I got an exceptional web development service delivered on time. As the process was seamless and fast with no hassle</p>
                    <div>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                    </div>
                </div>
            </slide>

            <slide>
                <div class="review-box p-4">
                    <h3 class="mb-3">Cynthia Agbor</h3>
                    <p>I was trained the nitty-gritty of building web application from scratch extensively</p>
                    <div>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                    </div>
                </div>
            </slide>


            <slide>
                <div class="review-box p-4">
                    <h3 class="mb-3">Jaiyeola Oladapo</h3>
                    <p>I thought online was never a thing for hair saloon business but I tried rendering all to dacode and suprisingly my business sales was trippled </p>
                    <div>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                    </div>
                </div>
            </slide>

            <slide>
                <div class="review-box p-4">
                    <h3 class="mb-3">Abeeb Akinola</h3>
                    <p>My website load time was three times lesser after I got my Laravel Web Application optimized by dacode</p>
                    <div>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                    </div>
                </div>
            </slide>
           
            
            </carousel>
        </div>

      </div>
    </section>
  </template>
  
  <script>
  import { Carousel, Slide } from 'vue-carousel';

  export default {
    components: {
      Carousel,
      Slide
    }
  }
  </script>
  
  <style>
  #review h2{
    color: var(--dacode-secondary-color);
    font-size: 1.3rem;
    text-align: center;
  }

  .review-box {
       border-top-right-radius: 1.5rem;
       border-bottom-left-radius: 1.5rem;
       border-bottom-right-radius: 1.5rem;
       background-color: #fdf5ea !important;
   }
    .review-box h3 {
        font-size: 1.1rem;
        color: var(--dacode-secondary-color) !important;
    } 

    .review-box p {
        opacity: .9;
    }

    .quote {
        font-size: 1.8rem;
        font-weight: bold;
    }
    
  </style>
  
  